export default __webpack_public_path__ + "static/media/previewImageIcon.c30151f0.png";